"use strict";

/**
 * CREE UN OBSERVER D'INTERSECTIONS
 * @param { { target: HTMLElement, root: ?HTMLElement, ratioIntersectionMin: ?number  } }
 * @info { si root vaut null => root = viewport }
 */
function InitIntersectionObserver({ target, root = null, ratioIntersectionMin = 0.9 }) {
    this.rootElement = root;
    this.targetElement =  target;
    this.ratioIntersectionMin = ratioIntersectionMin;
    this.observerPayloadFuncs = [];

    /**
    *  Handler appelé après l'intersection
    *  @param { IntersectionObserverEntry [] } entries
    *  @param { IntersectionObserver } observer
    */
    this.handler = (entries, _observer) => {
        entries.forEach(e => (e.isIntersecting && e.intersectionRatio >= this.ratioIntersectionMin) && this.execFuncs(this.observerPayloadFuncs), this);
    }

    this.observerInstance = new IntersectionObserver(this.handler, this.targetElement);
    /**
    *  Déclenche l'appel des fonctions de la pile
    *  @param { () => void [] } obserPayloadFuncs
    */
    this.execFuncs = (obserPayloadFuncs) => {
        obserPayloadFuncs.forEach(call => call());
    }

    /**
    *  Charge une pile
    *  @param { () => void [] } arrCallbacks
    */
    this.addPayLoadObserver = (arrCallbacks) => {
        this.observerPayloadFuncs = arrCallbacks;
    }

    /**
    *  Déclenche l'observer
    */
    this.runObserver = () => {
        this.observerInstance.observe(this.targetElement);
    }
}

/**
 * Fabrique une instance d'InitIntersectionObserver et la déclenche
 * @param {{ target: HTMLElement, root: ?HTMLElement, ratioIntersectionMin: ?number  }} params
 * @param {() => void []} arrCallbacks
 */
function factoryIntersectionObs(params, arrCallbacks) {
    const instanceOfInitObserver = new InitIntersectionObserver(params);
    instanceOfInitObserver.addPayLoadObserver(arrCallbacks);
    instanceOfInitObserver.runObserver();
    return instanceOfInitObserver;
}
